<template>
    <b-container fluid>
        <b-row align-h="around"
            ><b-col cols="2">
                <b-button
                    class="align-right mt-p16"
                    @click="generateReport"
                    size="sm"
                    v-b-tooltip.hover
                    title="Export To PDF"
                >
                    <b-icon icon="download" font-scale="1"></b-icon>
                    Download PDF
                </b-button>
            </b-col>
        </b-row>

        <b-card title="Usage Display" ref="inventoryUsageReport">
            <b-card-header> {{ startDt }} to {{ endDt }} </b-card-header>
            <b-card-body>
                <b-table-simple bordered>
                    <b-thead>
                        <b-tr>
                            <b-th>Suppliers</b-th>
                            <b-th
                                v-for="(vendor, vIdx) in vendors"
                                :key="'vendor-name' + vIdx"
                                :colspan="vendor.items.length"
                                class="text-center"
                            >
                                {{ vendor.name }}
                            </b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr>
                            <b-th>{{
                                (settings.bundledProduct &&
                                    settings.bundledProduct.title) ||
                                'Bundled Product'
                            }}</b-th>
                            <template v-for="(vendor, vIdx) in vendors">
                                <b-th
                                    v-for="(product, pIdx) in vendor.items"
                                    :key="'product-name' + vIdx + pIdx"
                                >
                                    {{
                                        settings.bundledProductType == 'both'
                                            ? `${product.name}/${product.container.name}`
                                            : product.name
                                    }}
                                </b-th>
                            </template>
                        </b-tr>
                        <b-tr
                            v-for="(heading, hIdx) in features"
                            :key="'heading' + hIdx"
                        >
                            <b-th>{{
                                (heading.title || heading.id) | formatTitle
                            }}</b-th>
                            <template v-for="(vendor, vIdx) in vendors">
                                <b-td
                                    v-for="(product, pIdx) in vendor.items"
                                    :key="'product-name2' + vIdx + pIdx"
                                >
                                    {{
                                        (bundledItemsBreakdowns &&
                                            bundledItemsBreakdowns[vIdx] &&
                                            bundledItemsBreakdowns[vIdx][
                                                pIdx
                                            ] &&
                                            bundledItemsBreakdowns[vIdx][pIdx][
                                                heading.id
                                            ]) ||
                                        0
                                    }}
                                </b-td>
                            </template>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
                <b-card
                    title-tag="h6"
                    :title="
                        (settings.subProductTotalsBySize &&
                            settings.subProductTotalsBySize.title) ||
                        'Totals By Size'
                    "
                    class="mb-2"
                >
                    <b-card-body>
                        <b-container class="bv-example-row">
                            <b-row class="justify-content-md-center">
                                <b-col
                                    v-for="(item, idx) in sizes"
                                    :key="'size--' + idx"
                                >
                                    <b-card
                                        title-tag="h6"
                                        :title="`${item.size} ${item.uom}`"
                                    >
                                        <b-card-text>{{
                                            item.qty
                                        }}</b-card-text>
                                    </b-card>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-card-body>
                </b-card>

                <b-card
                    title-tag="h6"
                    :title="
                        (settings.secondaryItemsClosingBalances &&
                            settings.secondaryItemsClosingBalances.title) ||
                        'Accessories'
                    "
                    class="mb-2"
                >
                    <b-container fluid>
                        <b-row class="justify-content-md-center">
                            <b-col
                                v-for="(item, idx) in minorItemsClosingBalances"
                                :key="'minorItems--' + idx"
                            >
                                <b-card :title="item.name" title-tag="h6">
                                    <b-card-text>{{ item.qty }}</b-card-text>
                                </b-card>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-card>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
import html2pdf from 'html2pdf.js'
import moment from 'moment'
import { capitalCase } from 'change-case'
export default {
    name: 'DisplayDailyUsage',
    data() {
        return {}
    },
    filters: {
        formatTitle(val) {
            return capitalCase(val)
        },
    },
    props: {
        parseItem: {
            type: Function,
            require: true,
        },
        vendors: {
            type: Array,
            default: () => [],
        },
        settings: {
            type: Object,
            default: () => ({}),
        },
        headings: {
            type: Array,
            require: true,
        },

        minorItems: {
            type: Array,
            default: () => [],
        },
        orderTypes: {
            type: Array,
            default: () => [],
        },

        sectionId: { type: [Number], require: true },

        openingTime: { type: [Number], require: true },
        closingTime: { type: [Number], require: true },
    },
    computed: {
        features() {
            const { settings } = this
            return this.headings
                .filter(id => !!(settings[id] && settings[id].required))
                .map(id => ({ id, title: settings[id].title }))
        },
        startDt() {
            return moment(new Date(this.openingTime)).format('YYYY-MM-DD HH:mm')
        },
        endDt() {
            return moment(new Date(this.closingTime)).format('YYYY-MM-DD HH:mm')
        },
        bundledItemsBreakdowns() {
            const {
                vendors,
                closingTime,
                openingTime,
                getBreakDowns,
                getBreakdownValue,
                headings,
            } = this
            const _breakdowns = {}
            for (let vIdx = 0; vIdx < vendors.length; vIdx++) {
                const _vendor = vendors[vIdx]
                _breakdowns[vIdx] = {}
                for (let pIdx = 0; pIdx < _vendor.items.length; pIdx++) {
                    const product = _vendor.items[pIdx]
                    _breakdowns[vIdx][pIdx] = {}
                    ////////////////////////
                    const vendor = {}
                    vendor[pIdx] = {}

                    const main = getBreakDowns(
                        product,
                        closingTime,
                        openingTime
                    )

                    const container = getBreakDowns(
                        product.container,
                        closingTime,
                        openingTime
                    )

                    for (const header of headings) {
                        _breakdowns[vIdx][pIdx][header] = getBreakdownValue(
                            header,
                            main,
                            container
                        )
                    }
                }
            }
            console.log({ _breakdowns })
            return _breakdowns
        },

        minorItemsClosingBalances() {
            const {
                minorItems,
                closingTime,
                openingTime,
                getBreakDowns,
                parseItem,
                sectionId,
            } = this
            const _items = []
            for (const product of minorItems) {
                const newItem = parseItem(product, sectionId)
                const { name } = newItem
                const _breakdown = getBreakDowns(
                    newItem,
                    closingTime,
                    openingTime
                )
                const qty = _breakdown.closingBalance || 0
                _items.push({ name, qty })
            }
            _items.sort((a, b) => a.name - b.name)
            return _items
        },

        sizes() {
            const { vendors, closingTime, openingTime, getBreakDowns } = this
            const _sizes = []
            for (const _vendor of vendors) {
                for (const product of _vendor.items) {
                    const container = getBreakDowns(
                        product.container,
                        closingTime,
                        openingTime
                    )

                    const { size } = product.container
                    const qty = container.closingBalance || 0
                    const uom = product.container.type.size_uom

                    let idx = _sizes.findIndex(x => x.size == product.size)
                    if (idx < 0) {
                        _sizes.push({ size, qty, uom })
                    } else {
                        _sizes[idx].qty += qty
                    }
                }
            }
            _sizes.sort((a, b) => a.size - b.size)
            return _sizes
        },
        transactionTypeOptions() {
            return this.$store.state.transactionType.options
        },
    },

    methods: {
        generateReport() {
            html2pdf(this.$refs.inventoryUsageReport, {
                margin: 1,
                filename: 'inventoryUsageReport.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { dpi: 192, letterRendering: true },
                pagebreak: {
                    before: '.newPage',
                    avoid: ['h2', 'h3', 'h4', '.field'],
                },
                jsPDF: {
                    unit: 'in',
                    format: 'letter',
                    orientation: 'portrait',
                },
            })
        },

        getBreakDowns(product, closingTime, openingTime) {
            const convertTime = dt_str => new Date(dt_str).getTime()
            const section = product.section || {}
            let { transactions: _transactions } = section
            //  const container = product.container

            _transactions = [...(_transactions || [])].map(x => {
                x.unix_time = convertTime(x.updated_at)
                return x
            })

            //sort in descending order
            _transactions.sort((a, b) => b.unix_time - a.unix_time)

            let closingIndex = _transactions.findIndex(
                trx => closingTime > trx.unix_time
            )

            if (closingIndex < 0) closingIndex = _transactions.length - 1

            let openingIndex = _transactions.findIndex(
                trx => openingTime > trx.unix_time
            )

            if (openingIndex < 0) openingIndex = _transactions.length - 1

            const closingBalance = _transactions
                .slice(0, closingIndex)
                .reduce((_closingBalance, trx) => {
                    _closingBalance += -trx.added_amount
                    return _closingBalance
                }, section.quantity_on_hand || 0)

            ////transactions window in correct order-- ascending
            const transactions = _transactions.slice(closingIndex, openingIndex)
            transactions.reverse()

            const openingBalance = transactions.reduce(
                (_openingBalance, trx) => {
                    _openingBalance += -trx.added_amount
                    return _openingBalance
                },
                closingBalance
            )

            return {
                closingBalance,
                openingBalance,
                transactions,
            }
        },

        getSales(transactions) {
            const {
                orderTypes,
                transactionTypeOptions: { entities, flows },
            } = this

            const outboundFlow = flows['Outbound']
            const customerEnt = entities['Customer']
            const internalRef = entities['Internal']

            const saleTypes = orderTypes.filter(
                x =>
                    x.transaction_type.flow === outboundFlow &&
                    x.transaction_type.entity === customerEnt &&
                    x.transaction_type.reference_entity === internalRef
            )
            const saleTransactions = transactions.filter(x =>
                saleTypes.some(y => y.id == x.order.order_type_id)
            )
            console.log('saleTransactions', saleTransactions)
            return saleTransactions
        },

        getReturns(transactions) {
            const {
                orderTypes,
                transactionTypeOptions: { entities, flows },
            } = this

            const inboundFlow = flows['Inbound']
            const customerEnt = entities['Customer']
            const internalRef = entities['Internal']

            const saleTypes = orderTypes.filter(
                x =>
                    x.transaction_type.flow === inboundFlow &&
                    x.transaction_type.entity === customerEnt &&
                    x.transaction_type.reference_entity === internalRef
            )
            const returnTransactions = transactions.filter(x =>
                saleTypes.some(y => y.id == x.order.order_type_id)
            )
            console.log('returnTransactions', returnTransactions)
            return returnTransactions
        },

        getPurchases(transactions) {
            const {
                orderTypes,
                transactionTypeOptions: { entities, flows },
            } = this

            const outboundFlow = flows['Outbound']
            const blackHoleRef = entities['Black Hole']
            const internalEnt = entities['Internal']

            const purchaseTypes = orderTypes.filter(
                x =>
                    x.transaction_type.flow === outboundFlow &&
                    x.transaction_type.entity === internalEnt &&
                    x.transaction_type.reference_entity === blackHoleRef
            )
            const purchaseTransactions = transactions.filter(x =>
                purchaseTypes.some(y => y.id == x.order.order_type_id)
            )
            console.log('purchaseTransactions', purchaseTransactions)
            return purchaseTransactions
        },

        getBreakdownValue(header, main, container) {
            switch (header) {
                case 'OpeningBundledCount':
                    return main.openingBalance || 0
                case 'OpeningUnbundledSubProductCount':
                    return (
                        (container.openingBalance || 0) -
                        (main.openingBalance || 0)
                    )
                case 'PurchasesPrincipalProduct': {
                    return this.getPurchases(main.transactions).reduce(
                        (_amt, trx) => {
                            _amt += trx.added_amount
                            return _amt
                        },
                        0
                    )
                }
                case 'PurchasesSubProduct': {
                    return this.getPurchases(container.transactions).reduce(
                        (_amt, trx) => {
                            _amt += trx.added_amount
                            return _amt
                        },
                        0
                    )
                }
                case 'SalesPrincipalProduct':
                    return this.getSales(main.transactions).reduce(
                        (_amt, trx) => {
                            _amt += -trx.added_amount
                            return _amt
                        },
                        0
                    )
                case 'SalesSubProduct':
                    return this.getSales(container.transactions).reduce(
                        (_amt, trx) => {
                            _amt += -trx.added_amount
                            return _amt
                        },
                        0
                    )
                case 'ReturnedUnbundledSubProductCount':
                    return this.getReturns(container.transactions).reduce(
                        (_amt, trx) => {
                            _amt += trx.added_amount
                            return _amt
                        },
                        0
                    )
                case 'ClosingBundledCount':
                    return main.closingBalance || 0
                case 'ClosingUnbundledSubProductCount':
                    return (
                        (container.closingBalance || 0) -
                        (main.closingBalance || 0)
                    )
                case 'TotalUnbundledSubProductCount':
                    return container.closingBalance || 0
            }
        },
    },
}
</script>

<style></style>
